import { memo, ReactElement, ReactNode } from 'react';
import clsx from 'clsx';
import { equals } from 'ramda';

export interface TitleMetaItemProps {
  onDark?: boolean;
  label: ReactNode;
  value: ReactNode;
}

function TitleMetaItemMemo({ onDark, label, value }: Readonly<TitleMetaItemProps>): ReactElement<TitleMetaItemProps> {
  return (
    <li
      className={clsx(
        'border-0 border-solid [&:not(:first-of-type)]:border-l',
        onDark ? 'border-blue-grey-100' : 'border-grey-300',
      )}
    >
      <div className="mx-2 flex flex-col text-left sm:mx-4 sm:w-max sm:text-right">
        {label && <span className={clsx('text-xs', onDark ? 'text-grey-200' : 'text-grey-400')}>{label}</span>}
        {value && <span className={clsx('sm:text-xl', onDark ? 'text-white' : 'text-black')}>{value}</span>}
      </div>
    </li>
  );
}

export const TitleMetaItem = memo(TitleMetaItemMemo, equals);
